import { EventMeta } from '../../../interfaces/meta.interface';

const EnableAddressListPaging: EventMeta<any> = {
    title: 'Address List container Enabled',
    default: {
        description: 'Address List container Enabled',
        longDescription: 'An Address List container was enabled.',
        severity: 'info',
    },
    classifications: [
        {
            severity: 'critical',
            description: (fields) => `A suspicious IP attempted to enable an AD address list view`,
            longDescription: (fields) =>
                `An Active Directory virtual list view for address lists was enabled from a suspicious IP address that is not in your allowed list. This could indicate an attempt to harvest directory information. `,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'danger',
            description: (fields) => `An unapproved IP attempted to enable an AD address list view`,
            longDescription: (fields) =>
                `An Active Directory virtual list view for address lists was enabled from an IP address that is not in your allowed list. This may indicate an attempt to access directory information. `,
            predicates: {
                isAllowedASN: false,
                isAllowedCountry: false,
                isAllowedRegion: false,
                isAllowedIP: false,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'warning',
            description: (fields) => `A suspicious IP enabled an address list container`,
            longDescription: (fields) =>
                `An Active Directory virtual list view for address lists was enabled. The action originated from a suspicious IP. While enabling address list containers may occur as part of directory administration, the use of a suspicious IP makes this entry noteworthy. This event is informational — it does not require immediate action but should be considered in the context of other activity for effective monitoring.`,
            predicates: {
                isFraudulentIP: true,
                isMicrosoftActivity: false,
            },
        },
        {
            severity: 'info',
            description: (fields) =>
                `A Microsoft system operation (synchronization server IP) enabled an address list container`,
            longDescription: (fields) =>
                `An Active Directory virtual list view for address lists was enabled. This was identified as a Microsoft system operation event, with the IP address associated with the Microsoft server responsible for synchronization. This entry is informational and reflects normal background activity. No immediate action is required unless unexpected changes to address list containers are detected.`,
            predicates: {
                isMicrosoftActivity: true,
            },
        },
        {
            severity: 'info',
            description: (fields) => `An address list container was enabled`,
            longDescription: (fields) =>
                `An Active Directory virtual list view for address lists was enabled. This is an informational record of a configuration change in directory services. No unusual conditions were detected with this event. It does not require immediate action unless the enabling of the address list container was unexpected.`,
        },
    ],
};

export default EnableAddressListPaging;
